import { useMemo } from 'react';

import { useAuth } from './useAuth';

export const usePermission = () => {
  const { permissions = [], role: userRole } = useAuth();

  return useMemo(() => {
    const can = (requirement) => {
      if (!requirement) return true;

      const { role, permission, dashboard, mode = 'OR', condition = false } = requirement;

      if (condition) return true;

      // 1. Perspective Gate
      if (dashboard && !permissions.includes(dashboard)) return false;

      // 2. Role Gate
      if (role && userRole !== role) return false;

      // 3. Permission Array Logic (Pure Permission Checking)
      if (permission) {
        const requiredPerms = Array.isArray(permission) ? permission : [permission];

        if (mode === 'AND') {
          return requiredPerms.every((p) => permissions.includes(p));
        }
        return requiredPerms.some((p) => permissions.includes(p));
      }

      return true;
    };

    return {
      can,
      has: (p) => permissions.includes(p),
    };
  }, [userRole, permissions]);
};
